import React from 'react';
import { GlobalNavigationLineOfBusiness } from 'src/common/__generated__/api/types';
import { DatePicker, Typeahead } from 'src/components/common/modules/form';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { PrimaryButton } from 'src/components/common/ui/button/button';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { getLocalizationData } from '../../../helpers';

export const FlightUitkStandardView: React.FC<any> = ({
    formState,
    updateTypeaheadFrom,
    localizationData,
    device,
    updateTypeaheadto,
    updateDates,
    searchdDateFormat,
    primaryButtonProps
}) => {
  return (
    <>
      <UitkLayoutFlex space="six" alignItems="center" justifyContent="end"></UitkLayoutFlex>
      <div className="grid">
        <UitkLayoutGrid className="wizard-row-top-margin">
          <UitkLayoutGridItem>
            <UitkLayoutGrid columns={{ small: 1, medium: 2, large: 3 }} space="three">
              <UitkLayoutGridItem>
                <Typeahead
                  controlid={formState?.leavingFrom?.typeHeadId}
                  label={getLocalizationData(localizationData, 'flying_from_label_copy', 'Flying From', device)}
                  icon={'place'}
                  name={'EGDSSearchFormLocationField-Location-origin_select'}
                  controller={'typeahead'}
                  updateModel={updateTypeaheadFrom}
                  placeholder={getLocalizationData(
                    localizationData,
                    'flying_from_placeholder_copy',
                    'City or Airport',
                    device
                  )}
                  value={formState?.leavingFrom.value}
                  hasClearButton={false}
                  lob={GlobalNavigationLineOfBusiness.FLIGHT}
                  error={formState?.leavingFrom?.error}
                />
              </UitkLayoutGridItem>
              <UitkLayoutGridItem>
                <Typeahead
                  controlid={formState?.goingTo?.typeHeadId}
                  label={getLocalizationData(localizationData, 'flying_to_label_copy', 'Flying to', device)}
                  icon={'place'}
                  name={'EGDSSearchFormLocationField-Location-destination_select'}
                  controller={'typeahead'}
                  updateModel={updateTypeaheadto}
                  placeholder={getLocalizationData(
                    localizationData,
                    'flying_to_placeholder_copy',
                    'City or Airport',
                    device
                  )}
                  value={formState?.goingTo?.value}
                  hasClearButton={false}
                  lob={GlobalNavigationLineOfBusiness.FLIGHT}
                  error={formState?.goingTo?.error}
                />
              </UitkLayoutGridItem>
              <UitkLayoutGridItem>
                <DatePicker
                  updateDates={updateDates}
                  startDate={formState?.departureDate?.value}
                  endDate={formState?.returnDate?.value}
                  startPlaceHolder={getLocalizationData(
                    localizationData,
                    'departure_date_label_copy',
                    'Departure Date',
                    device
                  )}
                  endPlaceHolder={getLocalizationData(
                    localizationData,
                    'return_date_label_copy',
                    'Return Date',
                    device
                  )}
                  startDateState={'packageStartDate'}
                  endDateState={'packageEndDate'}
                  singleMode={false}
                  doubleMonths={true}
                  selectCopy={getLocalizationData(localizationData, 'date_picker_select', 'Select Date', device)}
                  startLabel={getLocalizationData(
                    localizationData,
                    'departure_date_label_copy',
                    'Departure Date',
                    device
                  )}
                  endLabel={getLocalizationData(localizationData, 'return_date_label_copy', 'Return Date', device)}
                  singleDateSelect={true}
                  dateFormat={searchdDateFormat}
                />
              </UitkLayoutGridItem>
            </UitkLayoutGrid>
          </UitkLayoutGridItem>
          <UitkLayoutGridItem>
            <UitkLayoutGrid alignItems="center">
              <UitkLayoutGridItem>
                <div className="wizard-search-button-container">
                  <PrimaryButton {...primaryButtonProps} />
                </div>
              </UitkLayoutGridItem>
            </UitkLayoutGrid>
          </UitkLayoutGridItem>
        </UitkLayoutGrid>
      </div>
    </>
  );
};
